import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Product from '../views/Proudct.vue'
import News from '../views/News.vue'
import New from '../views/New.vue'
import cooperative from '../views/Cooperative.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// import { keepAlive } from 'vue'
const routes = [
  {
    path: '/',
    name: 'home',
    meta:{
      keepAlive:false
    },
    component: Home,
  },
  {
    path: '/news',
    name: 'news',
    meta:{
      keepAlive:true
    },
    component: News,
  },
  {
    path: '/product',
    name: 'product',
      meta:{
      keepAlive:false
    },
    component: Product,
  },
  {
    path: '/news/:id',
    name: 'new',
     meta:{
      keepAlive:true
    },
    component: New,
  },
  {
    path:'/cooperative',
    name:'cooperative',
      meta:{
      keepAlive:false
    },
    component:cooperative
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

// 路由加载的时候，使用页面加载进度工具进行监测：
router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})
// 路由加载完毕的时候，结束页面加载进度工具的监控：
router.afterEach((to, from, next) => {
  NProgress.done()
})

export default router
